"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/**
 * Custom hook to handle keyboard events.
 *
 * @param callback - The callback function to be executed when a keyboard event occurs.
 * @param [eventTypes=['keydown']] - The types of keyboard events to listen for.
 * @param [node=document] - The DOM node to attach the event listener to (defaults to document).
 */
const useKey = (callback, eventTypes = ['keydown'], node = document) => {
    (0, react_1.useEffect)(() => {
        for (const eventType of eventTypes) {
            node.addEventListener(eventType, callback);
        }
        return () => {
            for (const eventType of eventTypes) {
                node.removeEventListener(eventType, callback);
            }
        };
    }, [callback]);
};
exports.default = useKey;
